import { HStack, Skeleton } from '@chakra-ui/react';
import React from 'react';
import colors from '@/theme/colors';

const FADE_DURATION_SECONDS = 3;
const MARGIN_PX = '5px';
const SKELETON_ROW_HEIGHT_PX = '14px';

const NotificationsLoadingSkeleton = ({ count }: { count: number }) => {
  return new Array(count).fill(0).map((_, i) => (
    <div key={i} style={{ gap: '6px', marginTop: '10px' }}>
      <HStack width={'100%'} justifyContent={'space-between'} marginBottom={MARGIN_PX}>
        <Skeleton
          height={'20px'}
          width={'33%'}
          startColor={colors.extra.orange50pct}
          endColor={colors.extra.orange}
          fadeDuration={FADE_DURATION_SECONDS}
        />

        <Skeleton
          height={'20px'}
          width={'33%'}
          startColor={colors.text.mediumGray}
          endColor={colors.text.mediumGray}
          fadeDuration={FADE_DURATION_SECONDS}
        />
      </HStack>

      <Skeleton
        color="text.mediumGray"
        height={SKELETON_ROW_HEIGHT_PX}
        marginY={MARGIN_PX}
        fadeDuration={FADE_DURATION_SECONDS}
      />
      <Skeleton
        color="text.mediumGray"
        height={SKELETON_ROW_HEIGHT_PX}
        marginY={MARGIN_PX}
        fadeDuration={FADE_DURATION_SECONDS}
      />

      <HStack height={'1px'} backgroundColor={'#33516D24'} width={'100%'} marginY={'15px'} />
    </div>
  ));
};

export default NotificationsLoadingSkeleton;
